// 设施管理API 如水泵等设备
import request from '@/utils/request'
/**
 *
 * @param data
 * @returns {*}
 */
export function facilityPage(params,data) {
    return request({
        url: '/facility/page',
        method: 'post',
        data,
        params
    })
}
/**
 *
 * @param data
 * @returns {*}
 */
export function facilityList(data) {
    return request({
        url: '/facility/list/'+data.categoryId,
        method: 'get'
    })
}

/**
 * 添加设施
 * @param data
 * @returns {*}
 */
export function facilityAdd(data) {
    return request({
        url: '/facility',
        method: 'post',
        data
    })
}
/**
 * 编辑设施
 * @param data
 * @returns {*}
 */
export function facilityEdit(data) {
    // console.log('设施编辑',data)
    return request({
        url: '/facility',
        method: 'put',
        data
    })
}
/**
 * 根据id删除设施记录
 * @param ids
 * @returns {*}
 */
export function facilityRemove(id) {
    return request({
        url: '/facility/'+id,
        method: 'delete'
    })
}
